export default `
  #graphql
  query amSocialLoginAccountData {
    amSocialLoginAccountData {
      type
      name
    }
  }
`;
